import TemplateManager from "./templates";
import PagesApp from "./pages";
import SettingsApp from "./settings";

export default TemplateManager;
export { TemplateManager, PagesApp, SettingsApp };